<template>
  <form class="form-container">
    <div class="photos-section-container">
      <div v-for="imageData in imagesList" :key="imageData.varName">
        <photo-field
          :disabled="disabled"
          :image-data="imageData"
          :previousPhoto="getPhoto(imageData.varName)"
          @updatePhoto="updatePhoto($event)"
          @removePhoto="removePhoto($event)"
          ref="photos"
        />
      </div>
      <!-- <div data-app>
        <div v-if="!disabled && extraPhotosQuantity" class="flex-vertical photo-area-container">
          <div class="flex-vertical photo-container">
            <div class="input-container fill-space"
            :style="{'background-image': `url(${moreCopyIcon})`}"
            @change="onPhotoUploaded">
              <input type="file"
                class="photo-input fill-space"
                accept="image/*"
                @click="addExtraPhoto"
                ref="file"
              />
            </div>
          </div>
          <div class="photo-name">Upload Photo</div>
        </div>
      </div> -->
    </div>
  </form>
</template>

<script>
import PhotoField from "./PhotoField";
// import moreCopyIcon from "@/assets/home/photosForm/more_copy.png";

export default {
  name: "FormsPhotoSection",
  // data() {
  //   return {
  //     moreCopyIcon,
  //     countExtras: 0
  //   };
  // },
  components: { PhotoField },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    imagesList: {
      type: Array,
      required: true
    },
    previousImages: {
      type: Array
    }
  },

  // mounted() {
  //   this.countExtras = 0;
  //   for (let i = 0; i < this.imagesList.length; i++) {
  //     if(this.imagesList[i].name.includes("ExtraPhoto")){
  //       this.countExtras++;
  //     }
  //   }
  // },
  methods: {
    getPhoto(imageName) {
      return this.previousImages.find(image => {
        return image.name === imageName;
      });
    },

    updatePhoto(photo) {
      this.$emit("updatePhoto", photo);
    },
    removePhoto(photo) {
      this.$emit("removePhoto", photo);
    }
    // addExtraPhoto() {
    //   this.$refs.file.value = null;
    //   this.countExtras++;
    //   var numExtraPhoto = 1;
    //   for (let i = 0; i < this.imagesList.length; i++) {
    //     if(this.imagesList[i].name.includes("ExtraPhoto")){
    //       var auxExtra = Number(this.imagesList[i].name.split("Photo")[1]);
    //       if(auxExtra > numExtraPhoto) {
    //         numExtraPhoto = auxExtra;
    //       }
    //     }
    //   }
    //   var id = this.imagesList.length + 1;
    //   var name = "ExtraPhoto" + (numExtraPhoto + 1);
    //   this.imagesList.push({id: id, name: name});
    // },
    /*    onPhotoUploaded(photo) {
      this.$refs.photos[this.imagesList.length - 1].onFileChange(photo);
    }*/
  }
  // computed: {
  //   extraPhotosQuantity() {
  //     return (this.countExtras < 10);
  //   }
  // }
};
</script>

<style scoped>
.form-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
}
.photos-section-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: start;
  flex-wrap: wrap;
}

::-webkit-scrollbar {
  width: 4px;
}
::-webkit-scrollbar-thumb {
  background: #8c8e91;
}
::-webkit-scrollbar-track {
  background: #f0f0ef;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Photos/PhotosForm.vue